import api from "../../../../../services/api";

import React, { useState, useEffect } from "react";

import * as globalComponents from "../../../../../components";
import ListMenu from "../../../components/ListMenu";
import ListLink from "../../../components/ListLink";

import "../../styles.css";
import "./styles.css";

export default function MainMenu() {
  const [data, setData] = useState({
    resume: "",
    legislationContent: [],
  });

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get("/legislacao")
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, []);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs title="Legislação" dir={[]} />

      <div className="container">
        <div className="title__publications">
          <strong>Legislação</strong>

          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: data.resume }}
          ></div>

          <div className="legislation-menu">
            {data.legislationContent.map((value, index) => {
              if (value.Tipo === "menu") {
                return (
                  <ListMenu
                    key={index}
                    title={value.Titulo}
                    items={value.Itens}
                  />
                );
              } else if (value.Tipo === "link") {
                return (
                  <ListLink
                    key={index}
                    title={value.Titulo}
                    href={value.Link}
                  />
                );
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
